import script from "./HeaderUserDropdown.vue?vue&type=script&setup=true&lang=ts"
export * from "./HeaderUserDropdown.vue?vue&type=script&setup=true&lang=ts"

import "./HeaderUserDropdown.vue?vue&type=style&index=0&id=383c5c22&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-383c5c22"]])

export default __exports__